import { getAppServices } from 'providers/app-services';
import { ProjectId } from 'records/Project';
import { UserProfile } from 'records/UserProfile';
import GQLRequest from 'utils/GQLRequest';

export const createUserProfile = async (
  projectid: ProjectId,
  userProfile: UserProfile
): Promise<string> => {
  const input = {
    projectid,
    firstname: userProfile.firstname,
    lastname: userProfile.lastname,
    company: userProfile.company,
    role: userProfile.role,
  };

  const { setUserProjectInfo } = await new GQLRequest()
    .query(
      `
      mutation SetUserProjectInfo($input: SetUserProject!){
        setUserProjectInfo(input: $input)
      }
      `
    )
    .variables({ input })
    .json<{ setUserProjectInfo: string }>();

  return setUserProjectInfo;
};

export const setAnalyticsOptOut = async (optOut: boolean): Promise<boolean> => {
  const { authService } = getAppServices();
  const { userId } = authService.getCredentials();
  const resp = await fetch(
    `https://app.pendo.io/api/v1/metadata/visitor/pendo/value/${userId}/donotprocess`,
    {
      method: 'PUT',
      mode: 'cors',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
        'x-pendo-integration-key': '5d655bee-58f3-45ec-7b9b-a89aedd421c4.us',
      },
      body: JSON.stringify({
        optOut,
      }),
    }
  );

  return resp.ok;
};

export const getAnalyticsOptOut = async (): Promise<boolean> => {
  const { authService } = getAppServices();
  const { userId } = authService.getCredentials();
  const resp = await fetch(
    `https://app.pendo.io/api/v1/metadata/visitor/pendo/value/${userId}/donotprocess`,
    {
      method: 'GET',
      mode: 'cors',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
        'x-pendo-integration-key': '5d655bee-58f3-45ec-7b9b-a89aedd421c4.us',
      },
    }
  );

  if (resp.ok) {
    const respVal = await resp.text();
    console.log(respVal);
    return respVal.includes('true');
  }
  return false;
};
